import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { EventData } from 'src/utils/event-gateway';

export const shakePermissionAtom = atom<ShakePermission>('rejected');

export interface DebugEventLog<T = object> extends EventData<T> {
  date: string;
}
export const debugEventLogsAtom = atom<DebugEventLog[]>([]);

export const debugEventLogFilterAtom = atom({
  eventType: '',
  eventName: '',
});

export const globalApiDelayEnabledAtom = atomWithStorage<boolean>(
  'debug:globalApiDelayEnabled',
  false,
  undefined,
  { getOnInit: true }
);

export const globalApiDelayAtom = atomWithStorage<number>('debug:globalApiDelay', 0, undefined, {
  getOnInit: true,
});

export const apiDelayAtom = atomWithStorage<number>('debug:apiDelay', 0, undefined, {
  getOnInit: true,
});

export interface ApiDelayWhitelist {
  rpcMethods: string[];
  restPaths: string[];
  restPatterns: string[];
}

export const apiDelayWhitelistAtom = atomWithStorage<ApiDelayWhitelist>(
  'debug:apiDelayWhitelist',
  {
    rpcMethods: [],
    restPaths: [],
    restPatterns: [],
  },
  undefined,
  { getOnInit: true }
);

export const compiledApiDelayPatternsAtom = atom((get) => {
  const whitelist = get(apiDelayWhitelistAtom);
  return whitelist.restPatterns
    .map((pattern) => {
      try {
        return new RegExp(pattern);
      } catch {
        return null;
      }
    })
    .filter((r): r is RegExp => r !== null);
});
